import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@mm/components';
import { ChatWidgetDiagnosticResultExtraStyle } from '@mm/state/interfaces/chatWidgetTroubleshooting';
import { chatWidgetTroubleshootingLastResultSelector } from '@mm/state/selectors/chatWidgetTroubleshootingSelectors';
import { Result } from '../ChatWidgetTroubleshootingToolResult';

type Props = {
  isXRay?: boolean;
};

const renderExtraStyles = (styles: ChatWidgetDiagnosticResultExtraStyle[]) => {
  return (
    <div className="chat-widget-troubleshooting-tool-result__more-info">
      <strong>CSS rules detected:</strong>
      <ul>
        {styles.map(s => (
          <li>
            <code>{s.source.sourceURL}</code>
            {s.rule && <pre>{s.rule}</pre>}
          </li>
        ))}
      </ul>
    </div>
  );
};

export const useDetectConflictingCSSForFBResult = (props: Props): Result => {
  const { isXRay } = props;
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);
  const [expanded, setExpanded] = useState(false);
  if (!result?.widgets?.fbCustomerChatExtraStyles || isXRay) {
    return;
  }

  if (result.widgets.fbCustomerChatExtraStyles?.length) {
    return {
      result: 'info',
      description: (
        <>
          CSS rules detected on your website. Check below if the Facebook
          Customer Chat widget is not displaying properly.{' '}
          <Button
            color="transparent"
            css={{
              container:
                'chat-widget-troubleshooting-tool-result__toggle-button',
            }}
            onClick={() => setExpanded(s => !s)}
          >
            {expanded ? 'Hide' : 'Show'} Details
          </Button>
          {expanded &&
            renderExtraStyles(result.widgets.fbCustomerChatExtraStyles)}
        </>
      ),
    };
  }
};

export const useDetectConflictingCSSForWebchatResult = (
  props: Props,
): Result => {
  const { isXRay } = props;
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);
  const [expanded, setExpanded] = useState(false);
  if (!result?.widgets?.webchatExtraStyles || isXRay) {
    return;
  }
  if (result.widgets.webchatExtraStyles?.length) {
    return {
      result: 'info',
      description: (
        <>
          CSS rules detected on your website. Check below if the Webchat widget
          is not displaying properly.{' '}
          <Button
            color="transparent"
            css={{
              container:
                'chat-widget-troubleshooting-tool-result__toggle-button',
            }}
            onClick={() => setExpanded(s => !s)}
          >
            {expanded ? 'Hide' : 'Show'} Details
          </Button>
          {expanded && renderExtraStyles(result.widgets.webchatExtraStyles)}
        </>
      ),
    };
  }
};
